<template>
    <form id="mainForm" action="#" method="post">
        <Card>
            <template #title>
                <Toolbar>
                    <template #left>
                        <div class="p-card-title">
                            [{{mode}}] {{$t('release_matrix')}}
                        </div>
                        <div style="margin-left: 10px" v-if="mode != this.$FORM_MODE_CREATE">
                            <Button type="button" icon="pi pi-info" @click="toggle" aria:haspopup="true" aria-controls="overlay_panel" class="p-button-rounded p-button-outlined p-button-sm" />

                            <OverlayPanel ref="op" appendTo="body" :showCloseIcon="true" id="overlay_panel" style="width: 550px" :breakpoints="{'960px': '80vw'}">
                                <div class="grid field">
                                    <div class="row">
                                        <i class="pi pi-plus-circle" /> {{this.$formatDateTime(header.Created_Date)}}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{header.Created_By}}
                                    </div>
                                </div>
                                <div class="grid field" v-if="header.Edited_Date">
                                    <div class="row">
                                        <i class="pi pi-pencil" /> {{this.$formatDateTime(header.Edited_Date)}}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{header.Edited_By}}
                                    </div>
                                </div>
                            </OverlayPanel>
                        </div>
                    </template>

                    <template #right>
                        <Button icon="pi pi-chevron-left" :label="$t('back')" class="p-button mr-2" @click="backToIndex" />
                        <Button icon="pi pi-save" label="Save" class="p-button-success" @click="confirm($event)" 
                            v-if="mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW"/>
                        <Button icon="pi pi-trash" label="Delete" class="p-button-danger" @click="confirmDelete($event)"
                            v-if="mode == this.$FORM_MODE_DELETE"/>
                        <ConfirmPopup></ConfirmPopup>
                    </template>
                </Toolbar>
            </template>
            <template #content>
                <div class="p-inputtext-sm p-fluid">
                    <div class="p-fluid grid">
                     
                        <div class="col-6">

                            <FormField :labelName="$t('code')" fieldName="Code" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputText v-model="header.Code" v-if="header" :placeholder="$t('code')"  :disabled="mode == $FORM_MODE_VIEW || mode == $FORM_MODE_DELETE || mode == $FORM_MODE_EDIT" />
                                <small v-if="header && !header.Code && submitted && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t('code')) }}
                                </small>
                            </FormField>

                            <FormField :labelName="$t('description')" fieldName="Description" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <Textarea v-model="header.Description" v-if="header" :placeholder="$t('description')" :disabled="mode == $FORM_MODE_VIEW || mode == $FORM_MODE_DELETE" />
                                <small v-if="header && !header.Description && submitted && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t('description')) }}
                                </small>
                            </FormField>

                            <FormField :labelName="$t('module')" fieldName="Module" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <CustomSelect name="Module" :filter="true"  v-if="header"
                                    v-model="header.Module" required="true" 
                                    placeholder="Please Select"
                                    :url="$API_URL + 'list/lookup'"
                                    :minLength="0"
                                    :params="{ group: $LOOKUP_GROUP.RELEASE_MODULE }" 
                                    :disabled="!canEdit"/>
                                <small v-if="header && !header.Module && submitted && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t('module')) }}
                                </small>
                            </FormField>

                            <FormField :labelName="$t('location')" fieldName="Location" v-model="header" labelClass="col-4" fieldClass="col-6"  v-if="!isUserMasterData">
                                <CustomSelect 
                                class="p-inputtext-sm" 
                                v-model="header.Location_Code" 
                                :url="this.$API_URL + 'list/location_code'" 
                                :minLength="0" 
                                :params="{ }" 
                                v-if="header" 
                                :disabled="mode != $FORM_MODE_CREATE"
                                :filter="true"
                                @change="onLocationCode($event)"
                                />
                                <small v-if="header && !header.Location_Code && submitted && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t('location')) }}</small>
                            </FormField>

                            <FormField :labelName="$t('company')" fieldName="Company_Code" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="header && header.Module != this.$ApprovalMatrixModule.MD">
                                <CustomSelect name="Company_Code" :filter="true"  v-if="header"
                                    v-model="header.Company_Code" required="true" 
                                    placeholder="Please Select"
                                    :url="$API_URL + 'list/company_code_release'"
                                    :minLength="0"
                                    :params="{location_code:this.header.Location_Code }" 
                                    :disabled="mode != $FORM_MODE_CREATE"/>
                                    <small v-if="header && !header.Company_Code && submitted && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t('module')) }}</small>
                            </FormField>

                            <!-- <FormField :labelName="$t('company_contractor')" fieldName="Contractor_Code" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="header && header.Module == this.$ApprovalMatrixModule.TRANSACTION">
                                <CustomSelect name="Contractor_Code" :filter="true"  v-if="header"
                                    v-model="header.Contractor_Code" required="true" 
                                    placeholder="Please Select"
                                    :url="$API_URL + 'list/contractor_code'"
                                    :minLength="0"
                                    :params="{ }" 
                                    :disabled="mode != $FORM_MODE_CREATE"/>
                                    <small v-if="header && !header.Contractor_Code && submitted && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t('module')) }}</small>
                            </FormField> -->

                            <!-- <FormField :labelName="$t('budget_allocation')" fieldName="Budget_Allocation" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputText v-model="header.Budget_Allocation" v-if="header" :placeholder="$t('budget_allocation')"  :disabled="mode == $FORM_MODE_VIEW || mode == $FORM_MODE_DELETE" />
                            </FormField> -->
                            <!-- <FormField :labelName="$t('company')" fieldName="Company" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <CustomSelect 
                                    class="p-inputtext-sm" 
                                    v-model="header.Company" 
                                    :url="this.$API_URL + 'list/company_code'" 
                                    :minLength="0" 
                                    :params="{ }" 
                                    v-if="header" 
                                    :disabled="mode == $FORM_MODE_VIEW || mode == $FORM_MODE_DELETE"
                                    :filter="true"
                                    />
                            </FormField> -->

                            <!-- <FormField :labelName="$t('department')" fieldName="Department" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <CustomSelect 
                                class="p-inputtext-sm" 
                                v-model="header.Department" 
                                :url="this.$API_URL + 'list/department_code'" 
                                :minLength="0" 
                                :params="{ }" 
                                v-if="header" 
                                :disabled="mode == $FORM_MODE_VIEW || mode == $FORM_MODE_DELETE"
                                :filter="true"
                                />
                            </FormField> -->


                        </div>
                        <div class="col-6">
                           
                            <!-- <FormField :labelName="$t('type')" fieldName="Type" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputText v-model="header.Type" v-if="header" :placeholder="$t('type')"  :disabled="mode == $FORM_MODE_VIEW || mode == $FORM_MODE_DELETE" />
                            </FormField> -->
                          
                            
                            <FormField :labelName="$t('validity')" fieldName="Validity" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <CustomSelect name="Validity" :filter="true"  v-if="header"
                                    v-model="header.Validity" required="true" 
                                    placeholder="Please Select"
                                    :url="$API_URL + 'list/lookup'"
                                    :minLength="0"
                                    :params="{ group: $LOOKUP_GROUP.VALIDITY_MATRIX}" 
                                    :disabled="!canEdit"/>
                                <small v-if="header && !header.Validity && submitted && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t('validity')) }}
                                </small>
                            </FormField>

                            <FormField :labelName="$t('category')" fieldName="Category" v-model="header" labelClass="col-4" fieldClass="col-6">
                                
                                <CustomSelect name="Category" :filter="true"  v-if="header"
                                    v-model="header.Category" required="true" 
                                    placeholder="Please Select"
                                    :url="$API_URL + 'list/lookup'"
                                    :minLength="0"
                                    :params="{ group: this.header.Module  }" 
                                    :disabled="!canEdit"/>
                                <small v-if="header && !header.Category && submitted && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t('category')) }}
                                 </small>
                            </FormField>

                            <FormField :labelName="$t('reason')" fieldName="Status" v-model="header" labelClass="col-4" fieldClass="col-6 md-6" v-if="header && mode == this.$FORM_MODE_EDIT">
                                <InputText name="Reason" v-model="header.Reason" type="text" :placeholder="$t('reason')" 
                                v-if="header" :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT" v-on:blur="onBlur()"/>
                                <small v-if="header && !header.Reason && submitted && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t('reason')) }}
                                </small>
                            </FormField>

                            <!-- <FormField :labelName="$t('Contractor_Level')" fieldName="Status" v-model="header" labelClass="col-4" fieldClass="col-6 md-6">
                                <InputNumber name="Reason" v-model="header.Contractor_Level" type="text" :placeholder="$t('Contractor_Level')" 
                                v-if="header" :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"/>
                            
                            </FormField> -->

                            <!-- <FormField :labelName="$t('info1')" fieldName="Info1" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputText v-model="header.Info1" v-if="header" :placeholder="$t('info1')"  :disabled="mode == $FORM_MODE_VIEW || mode == $FORM_MODE_DELETE" />
                            </FormField>

                            <FormField :labelName="$t('info2')" fieldName="Info2" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputText v-model="header.Info2" v-if="header" :placeholder="$t('info2')"  :disabled="mode == $FORM_MODE_VIEW || mode == $FORM_MODE_DELETE" />
                            </FormField> -->
                        </div>

                        <div class="col-12">
                            <DataTable :loading="!header" v-if="header" :value="header.Details" responsiveLayout="scroll" class="p-datatable-sm editable-cells-table" :rowClass="hideRow">
                                <Column >
                                    <template #header>
                                        <Button label="" icon="pi pi-plus" class="p-button-primary p-mr-2 p-button-sm" @click="addDetail" :disabled="!canEdit" />
                                    </template>
                                    <template #body="slotProps">
                                        <Button icon="pi pi-minus" class="p-button-danger p-mr-2 p-button-sm" @click="deleteDetail(slotProps)" :disabled="!canEdit" />
                                    </template>
                                </Column>

                                <Column field="Sign_Position" :header="$t('Sign_Position')" key="Level">
                                    <template #body="slotProps">
                                        <InputNumber :maxFractionDigits="0" v-if="header" v-model="slotProps.data[slotProps.column.props.field]" mode="decimal" @blur="onCellEditComplete(slotProps)" :disabled="!canEdit" />
                                    </template>  
                                </Column>

                                <Column Column field="Approval_As" :header="$t('approval_as')" key="Approval_As">
                                    <template #body="slotProps">
                                        <CustomSelect name="Approval_As" :filter="true"  
                                            v-model="slotProps.data[slotProps.column.props.field]" required="true" 
                                            :placeholder="$t('approval_as')"
                                            :url="$API_URL + 'list/lookup'"
                                            :minLength="0"
                                            :params="{ group: $LOOKUP_GROUP.APPROVAL_AS_MATRIX }"
                                            @change="onCellEditComplete(slotProps);"
                                            :disabled="!canEdit" />
                                    </template>
                                </Column>

                    
                                <Column field="Username" :header="$t('username')" key="Id" v-if="header && header.Module == this.$ApprovalMatrixModule.MD">
                                    <template #body="slotProps">
                                        <CustomSelect 
                                            v-model="slotProps.data[slotProps.column.props.field]" 
                                            :url="$API_URL + 'list/username_user_release'"
                                            :params="{ job_postion:slotProps.data.Approval_As, companycode : slotProps.data.Approval_As != this.$UserLevel.CONTRACTOR ? header.Company_Code : ''  , contractorcode : slotProps.data.Approval_As == this.$UserLevel.CONTRACTOR ? header.Contractor_Code : '', locationcode : this.header.Location_Code}" 
                                            :minLength="0" 
                                            :filter="true"
                                            @change="onCellEditComplete(slotProps); onchangeUserCode($event,slotProps.data)"
                                            :disabled="!canEdit"
                                            />
                                    </template>  
                                </Column>

                                <!-- <Column field="companycode" :header="$t('company')" key="Id">
                                    <template #body="slotProps">
                                        <CustomSelect v-if="slotProps.data.usertype == this.$UserType.WILMAR"
                                            v-model="slotProps.data[slotProps.column.props.field]" 
                                            :url="$API_URL + 'list/company_code'"
                                            :params="{ }" 
                                            :minLength="0" 
                                            :filter="true"
                                            @change="onCellEditComplete(slotProps)"
                                            :disabled="true"
                                            />
                                    </template>  
                                </Column>
                                
                                <Column field="contractorcode" :header="$t('company_contractor')" key="Id">
                                    <template #body="slotProps">
                                        <CustomSelect v-if="slotProps.data.usertype == this.$UserType.CONTRACTOR"
                                            v-model="slotProps.data[slotProps.column.props.field]" 
                                            :url="$API_URL + 'list/contractor_code'"
                                            :params="{ }" 
                                            :minLength="0" 
                                            :filter="true"
                                            @change="onCellEditComplete(slotProps)"
                                            :disabled="true"
                                            />
                                    </template>  
                                </Column> -->

                                <Column field="Level" :header="$t('level')" key="Level">
                                    <template #body="slotProps">
                                        <InputNumber :maxFractionDigits="0" v-if="header" v-model="slotProps.data[slotProps.column.props.field]" mode="decimal" @blur="onCellEditComplete(slotProps)" :disabled="!canEdit" />
                                    </template>  
                                </Column>
                            </DataTable>
                        </div>

                        <div class="col-12 mt-4" v-if="this.mode != this.$FORM_MODE_CREATE">
                            <TabView>
                                <TabPanel :header="$t('log_history')">
                                    <ChangeHistory v-if="this.header" :modelValue="this.dataModelReqLogs"
                                        :dataRequestLog="this.dataRequestLogs" :mode="this.mode"></ChangeHistory>
                                </TabPanel>
                                 <TabPanel :header="$t('Change_History')">
                                    <ChangeHistory v-if="this.header" :modelValue="this.detailLog" :dataRequestLog="this.dataChangesLog" :mode="this.mode"></ChangeHistory>
                                </TabPanel>
                            </TabView>
                        </div>  
                    </div>
                </div>
            </template>
        </Card>
    </form>

    <Dialog :header="'Are you sure to delete ?'" v-model:visible="showModalDelete" :closeOnEscape="false" :closable="false" :modal="true" :breakpoints="{'960px': '75vw', '640px': '100vw'}" :style="{width: '35vw'}">
        <div v-if="listDocImpact">
            {{listDocImpact.warningMessage}}
            <div style="max-height: 150px; overflow-y: auto;">
                <ol>
                    <li v-for="(item, index) in listDocImpact.Docno" :key="index">
                        {{ item }}
                    </li>
                </ol>
            </div>
        </div>

        <template #footer>
            <div>
                <Button label="No" @click="dimissModalDelete" />
                <Button label="Yes" autofocus @click="saveData"/>
            </div>
        </template>
    </Dialog>

</template>

<script>
    export default {
        name: "Editor",
        data() {
            return {
                indexName: "ReleaseMatrixIndex",
                url: this.$API_URL + "releasematrix/",
                header: null,
                detail: null,
                mode: "",
                id: 0,
                formEditable: true,
                submitted : false,
                dataChangesLog:this.$dataChangesLogMasterData,
                detailLog : null,
                dataModelReqLogs: [],
                dataRequestLogs: [
                    { field: "Action_Role", header: "Role" },
                    { field: "Action_By", header: "Action By" },
                    { field: "Action", header: "Action" },
                    { field: "Action_Date", header: "Action Date" },
                    { field: "Notes", header: "Notes" },
                ],
                listDocImpact : null,
                showModalDelete : false
            }
        },
        methods: {
            confirmDelete(){
                this.showModalDelete = true;
            },
            dimissModalDelete(){
                this.showModalDelete = false;
            },
            onLocationCode(e){
                if(!e){
                    this.header.Company_Code = null;
                }
            },  
            onchangeUserCode(e,data){
                if(e!=null){
                    data.companycode = e.companycode;
                    data.contractorcode = e.contractorcode;
                    data.usertype = e.usertype;
                    
                }else{
                    data.companycode = null;
                    data.contractorcode = null;
                    data.usertype = null;
                }
            },
            getData() {
                var self = this;
                this.$axios.get(this.url + this.id + "/" + this.mode)
                    .then((response) => {
                        self.header = response.data.data.header;
                        self.header.mode = self.mode;
                        self.detail = response.data.data.detail;
                        self.dataModelReqLogs = response.data.data.header.request_log;
                        self.listDocImpact = response.data.data.documenImpact;
                        self.detailLog = self.header.DetailLog;
                    })
                    .catch(function (error) {
                    });
            },
            saveData() {
                this.$emit('block-ui');
                var self = this;
                self.showModalDelete = false;
                this.$axios.post(this.url, this.header)
                    .then((response) => {
                        if (response.data.success) {
                            self.$router.push({ name: this.indexName, params: { showToast: true, severity: 'success', summary: 'Data Saved', detail: response.data.message, life: 120000} } );
                        }
                        else {
                            self.showError('Error Saving Data', response.data.message);
                        }
                    })
                    .catch(function (error) {
                        self.showError('Error Saving Data', error);
                    });
            },
            showError(summary, message) {
                this.$emit('unblock-ui');
                this.$toast.add({ severity: 'error', summary: summary, detail: message, life: 120000});
            },
            backToIndex() {
                this.$router.push({ path: "/ReleaseMatrix/Index" });
            },
            toggle(event) {
                this.$refs.op.toggle(event);
            },
            confirm(event) {
                this.submitted = true;
                //|| (!this.header.Contractor_Code && this.header.Module == this.$ApprovalMatrixModule.TRANSACTION)
                var isUserMasterData = this.header.Module == this.$ApprovalMatrixModule.MD && this.header.Category == this.$ACCOUNT.USER;
                if(!this.header.Code || !this.header.Description || !this.header.Module || !this.header.Validity|| (!this.header.Location_Code && !isUserMasterData) || !this.header.Category || (!this.header.Company_Code && this.header.Module == this.$ApprovalMatrixModule.TRANSACTION) ||
                    (this.mode == this.$FORM_MODE_EDIT && !this.header.Reason))
                    return false;
                    
                let deleteDetail = this.header.Details.filter(a=> a.mode == this.$FORM_MODE_DELETE);

                if(this.header.Details.length == 0){
                    this.showError('Error Saving Data', "At least one or more approver required");
                    return false;
                }else if(deleteDetail.length == this.header.Details.length ){
                    this.showError('Error Saving Data', "At least one or more approver required");
                    return false;
                }

                this.$confirm.require({
                    target: event.currentTarget,
                    message: 'Are you sure?',
                    icon: 'pi pi-exclamation-triangle',
                    accept: () => {
                        this.saveData();
                    },
                    reject: () => {
                        //callback to execute when user rejects the action
                    }
                });
            },
            addDetail() {
                var newDetail = this.detail;
                newDetail.mode = this.$FORM_MODE_CREATE;
                var det = { ...newDetail };
                this.header.Details.push(det);
            },
            deleteDetail(event) {
                if (event) {
                    var detail = this.header.Details[event.index];

                    if (detail.mode == this.$FORM_MODE_CREATE) this.header.Details.splice(this.header.Details.indexOf(detail), 1);
                    else detail.mode = this.$FORM_MODE_DELETE;
                }
            },
            onCellEditComplete(event) {
                this.editDetail(event.index);
            },
            editDetail(index) {
                if (this.header.Details && this.header.Details.length > 0) {
                    let m = this.header.Details[index].mode;

                    if (m == this.$FORM_MODE_UNCHANGED) {
                        this.header.Details[index].mode = this.$FORM_MODE_EDIT;
                    }
                }
            },
            hideRow(data) {
                return data.mode == this.$FORM_MODE_DELETE ? 'row-hidden' : null;
            },
        },
        created() {
            this.mode = this.$route.query.mode;
            this.id = this.$route.query.id ?? 0;

            this.getData();
        },
        computed:{
            noEdit(){
                return this.mode == this.$FORM_MODE_DELETE || this.mode == this.$FORM_MODE_VIEW;
            },
            canEdit(){
                return this.mode == this.$FORM_MODE_CREATE || this.mode == this.$FORM_MODE_EDIT;
            },
            isUserMasterData(){
                return this.header && this.header.Module == this.$ApprovalMatrixModule.MD && this.header.Category == this.$ACCOUNT.USER;
            }
        }
    }
</script>